module.exports = __webpack_public_path__ + "media/images/donate-any-1a02d403fe6b9c651d432fde727a8904.jpg";